import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { safeStorageGet, safeStorageSet } from './storage'

const STORAGE_KEY = 'ui.theme'

function normalizeTheme(v) {
  const x = String(v || '').toLowerCase()
  if (x === 'dark') return 'dark'
  if (x === 'light') return 'light'
  return null
}

function getSystemTheme() {
  try {
    if (typeof window === 'undefined') return 'light'
    if (!window.matchMedia) return 'light'
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => normalizeTheme(safeStorageGet(STORAGE_KEY)) || getSystemTheme())

  useEffect(() => {
    safeStorageSet(STORAGE_KEY, theme)
    try {
      document.documentElement.classList.toggle('dark', theme === 'dark')
    } catch {
      // ignore
    }
  }, [theme])

  const value = useMemo(() => {
    const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))
    return { theme, setTheme, toggleTheme }
  }, [theme])

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) {
    return { theme: 'light', setTheme: () => {}, toggleTheme: () => {} }
  }
  return ctx
}

